export default "__VITE_ASSET__CWyNjXTu__"